import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export function dataViewRoutes($stateProvider: StateProvider): void {
    let dataViewModule: {default: any;};

    window.customDataViewPagesConfiguration.definedDataViewPages.forEach((definedDataViewPage) => {
        $stateProvider
            .state({
                name: `data-view-${definedDataViewPage.id}`,
                url: `/data-view/${definedDataViewPage.route}?activeTab`,
                params: {activeTab: {dynamic: true}},
                component: KpSvelteComponentWrapperComponent.componentName,
                resolve: {
                    component: () => dataViewModule.default,
                    props: () => ({configuration: definedDataViewPage})
                },
                lazyLoad: async () => {
                    dataViewModule = await import(/* webpackChunkName: "dataViewPage" */ './DataViewPage.svelte');
                    return null;
                }
            });
    });
}